var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from "@/hooks/store";
import { Slot, SlotDirection } from "@/utils/types/layout";
import { useSlotVisibility } from "@/hooks/layout";
import AddWidgetControl from "@/components/layout/edit/addWidget";
import WidgetGrid from "../widgetGrid";
import { useFilteredWidgets } from "@/utils/themes/hooks";
/**
 *
 * Composant DockWest
 */
export default function DockWest() {
    var dockWestVisible = useSlotVisibility().dockWestVisible;
    var filteredWidgets = useFilteredWidgets(Slot.DOCK_WEST);
    var isEditingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    var areaVisible = (dockWestVisible && filteredWidgets.length > 0) || isEditingLayout;
    if (areaVisible) {
        if (filteredWidgets.length === 0 && !isEditingLayout) {
            return _jsx(_Fragment, {});
        }
        return (_jsxs("aside", __assign({ className: " ".concat(isEditingLayout && "border-[2px] border-[var(--colors-widget-border)]", "  flex-none flex flex-col bg-[var(--colors-dock-west-bg)] direction-vertical scroll-contain relative w-[16rem] h-full overflow-hidden\n      mt-[var(--margin-mt-dock-west)] mr-[var(--margin-mr-dock-west)]\n      mb-[var(--margin-mb-dock-west)] ml-[var(--margin-ml-dock-west)]") }, { children: [_jsx("div", __assign({ className: "relative w-full h-full overflow-hidden widgets-container scroll-elements" }, { children: _jsx("div", __assign({ className: "flex flex-row items-center justify-start h-full" }, { children: _jsx(WidgetGrid, { direction: SlotDirection.VERTICAL, filteredWidgets: filteredWidgets, isEditingLayout: isEditingLayout }) })) })), isEditingLayout && _jsx(AddWidgetControl, { to: Slot.DOCK_WEST })] })));
    }
    return _jsx(_Fragment, {});
}
